"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
exports.default = vue_1.default.extend({
    name: "v-inline-dropdown-multiselect-editor",
    props: {
        component: {
            type: Function,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        currentOptions: {
            type: Array,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: true
        }
    },
    beforeMount: function () {
        this.$options.components.component = this.component;
    },
    data: function () {
        return {
            state: "value",
            _currentOptions: this.currentOptions
        };
    },
    watch: {
        currentOptions: function () {
            this.$data._currentOptions = this.currentOptions;
        }
    },
    methods: {
        switchState: function () {
            if (this.canEdit) {
                this.state = (this.state === "value") ? "component" : "value";
            }
        },
        onChange: function (options) {
            this.$data._currentOptions = options;
            this.$emit("update", options);
        }
    }
});
